import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'
import { isFarmi } from '@b2ag/app-brands'
import { useFeatureFlipping } from '@b2ag/feature-flipping'
import { getAppContext } from '@b2ag/micro-front-tools'
import { PAGE_ANALYTICS_INFO, PAGE_TYPE } from '../page-types'
import { useRequestHeader } from '#imports'
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded, NavigationGuardNext } from 'vue-router'

const { isFrontTech } = getAppContext()

/* ------- PARENT - CORE - AGRI ------- */

const coreRoutesAgri = [
  {
    path: '/',
    name: 'home',
    component: () => import('@b2ag/micro-front-home/app'),
    props: () => {
      return {
        microFrontName: 'home',
        viewName: 'home',
      }
    },
    beforeEnter(_to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) {
      const { isPortalEntriesEnabled } = useFeatureFlipping()

      if (isPortalEntriesEnabled.value && !isWebViewFarmi(useRequestHeader('user-agent'))) {
        next({ name: 'portal-home' })
      } else if (isFarmi && isWebViewFarmi(useRequestHeader('user-agent'))) {
        next({ name: 'farmi-app-appro-categories' })
      } else {
        next()
      }
    },
    meta: {
      analyticsPageType: PAGE_TYPE.HOME,
    },
  },
]

/* ------- PARENT - CORE - TECH ------- */

const coreRoutesTech = [
  {
    path: '/',
    name: 'home',
    component: () => import('@b2ag/micro-front-dashboard-tech/app'),
    props: () => {
      return {
        microFrontName: 'dashboard-tech',
        viewName: 'home',
        useAnalyticService,
      }
    },
    beforeEnter(_to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) {
      if (isFarmi && isWebViewFarmi(useRequestHeader('user-agent'))) {
        next({ name: 'search' })
      } else {
        next()
      }
    },

    meta: {
      analyticsPageInfo: PAGE_ANALYTICS_INFO.HOME,
      changeSelectedCustomer: true,
      isSearchPage: false,
      private: true,
      showAppFooter: true,
      showSearchBar: true,
      showSelectedCustomer: true,
      showWelcomeHeader: true,
    },
  },
]

/* ------- PARENT - CORE - Choice ------- */

export const coreRoutes = isFrontTech ? coreRoutesTech : coreRoutesAgri
